// removed by extract-text-webpack-plugin
module.exports = {"CTAButton":"CTAButton---1Peeb"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/shared-web/src/components/widget/TakeoverCampaign/CTAButton/style.styl
// module id = 10s7
// module chunks = 88